// 事件总线（mitt库）

import type { CollectLabel } from '@/api/common.api'
import type { MyRecordData } from '@/views/common/TopicPage/api/index.api'
import mitt, { type Emitter } from 'mitt'
import type { WordScore } from './tool'

type Events = {
  /**单词释义弹框 */
  word: {
    wordStr: string
    termName: string
    sectionResult?: WordScore
  }
  /**提交做题 */
  submit: {
    questionId: number | string
    questionsTypeCode: string
    step?: number
    content?: string
    shareId?: number | string
    wfd?: any
  }
  /**收藏夹弹框 */
  'collect-popup': cllectData
  'expspeaking-score': MyRecordData
  'asq-score': AsqScore
  'expwriting-score': number
  // 收藏事件
  collect: {
    id: number
    color: number
  }
  //练习设置弹窗
  'practiceSetting-popup': string
  // 模考保存
  mockSave: any
  // 模考停止
  mockStop: any
  openWindowPopup: number | boolean
}
export interface cllectData {
  label: CollectLabel
  qid?: number
  word?: string
  termName?: string
  succeed?: (color: 1 | 2 | 3 | 4) => void
}

export interface AsqScore {
  overall: number
  fluency: number
  pronunciation: number
  audioUrl: string
  id: number | string
  postId: number
  xfWords?: string
  words?: string
}
const emitter: Emitter<Events> = mitt()
export default emitter
